
import MessageTemplate from './routes/message_template/MessageTemplate.vue';
import MessageTest from './routes/message_test/MessageTest.vue';

const PaxelinMarketRoutes = [
    {
        path: 'message-template',
        name: 'MessageTemplate',
        component: MessageTemplate,
    },
    {
        path: 'message-test',
        name: 'MessageTest',
        component: MessageTest,
    },
];

export default PaxelinMarketRoutes;
